import {
    BackendType,
    FrontendType,
    ObjectType,
    StarjackDate,
} from '@starjack/utils';
import { Money } from '../../money';
import { convertDateFromDateArray } from '@starjack/utils';

export type LiftOperatorBilling = {
    liftOperatorId: string;
    producedTickets: number | null;
    producedTicketsSum: Money | null;
    cancelledTickets: number | null;
    cancelledTicketsSum: Money | null;
    billedKeycards: number | null;
    billedKeycardsSum: Money | null;
    billedShopProductsSum: Money | null;
    internalProductionsCreditTotal: Money | null;
    success?: boolean;
};

export type Billing<T extends ObjectType = FrontendType> = {
    id: string;
    billingPeriodFrom: StarjackDate<T>;
    billingPeriodTo: StarjackDate<T>;
    createdAt: StarjackDate<T>;
    errorLiftOperatorIds: string[];
    successLiftOperatorIds: string[];
    releasedAt: StarjackDate<T>;
    releasedBy: StarjackDate<T>;
    liftOperators?: LiftOperatorBilling[];
};

export const convertBillingToFrontend = (
    billing: Billing<BackendType>
): Billing => ({
    ...billing,
    releasedAt: convertDateFromDateArray(billing.releasedAt),
    releasedBy: convertDateFromDateArray(billing.releasedBy),
    billingPeriodFrom: convertDateFromDateArray(billing.billingPeriodFrom),
    billingPeriodTo: convertDateFromDateArray(billing.billingPeriodTo),
    createdAt: convertDateFromDateArray(billing.createdAt),
});

export const hasEmptyBillingData = (
    billing: Billing,
    liftOperatorId: string | undefined
): boolean => {
    if (!liftOperatorId || !billing.liftOperators) {
        return false;
    }

    const liftOperatorData = billing.liftOperators.find(
        (lo) => lo.liftOperatorId === liftOperatorId
    );

    if (!liftOperatorData) {
        return false;
    }

    return (
        liftOperatorData.producedTickets === null &&
        liftOperatorData.producedTicketsSum === null &&
        liftOperatorData.cancelledTickets === null &&
        liftOperatorData.cancelledTicketsSum === null &&
        liftOperatorData.billedKeycards === null &&
        liftOperatorData.billedKeycardsSum === null &&
        liftOperatorData.billedShopProductsSum === null &&
        liftOperatorData.internalProductionsCreditTotal === null
    );
};
